module.exports = "/images/vendor/flag-icon-css/flags/1x1/pe.svg?23591f9d72b1e3ad2652099518e98f72";